"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#024965"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.27,24H.73A.65.65,0,0,1,0,23.26V.73A.65.65,0,0,1,.73,0H23.27A.65.65,0,0,1,24,.73V23.26A.65.65,0,0,1,23.27,24Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,10.59H13.41V4a1.41,1.41,0,0,0-2.81,0v6.62H4A1.41,1.41,0,0,0,4,13.4h6.62V20a1.41,1.41,0,0,0,2.81,0V13.4H20a1.41,1.41,0,0,0,0-2.81Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;